// extracted by mini-css-extract-plugin
export default {"clickable":"bu6fIW","round":"cu6fIW"};